export enum Experiment {
  EnableSectionsTabInMobileAS = 'specs.membersAboutOOI.enableSectionsMobileAS',
  EnableCSSOptimization = 'specs.membersAboutOOI.EnableCSSOptimization',
  AboutPublishValidation = 'specs.about.MembersAboutSpecs$ValidateLinksInAboutContent',
  BlogLiveSiteEditingDeprecation = 'specs.wixBlog.LiveSiteEditorDeprication',
  EnableMobileDesignTabSectionHeaders = 'specs.membersAboutOOI.EnableMobileDesignTabSectionHeaders',
  EnableButtonBorderSettings = 'specs.membersAboutOOI.EnableButtonBorderSettings',
  EnableMobileTitleSetting = 'specs.membersAboutOOI.EnableMobileTitleSetting',
  DisableButtonOnPublish = 'specs.membersAboutOOI.DisableButtonOnPublish',
  EnablePluralStatisticFix = 'specs.membersAboutOOI.EnablePluralStatisticFix',
  EnablePostListInSEO = 'specs.membersAbout.EnablePostListInSEO',
  EnableRicosContentInSEO = 'specs.membersAbout.EnableRicosContentInSEO',
  EnableWDSPanels = 'specs.membersAbout.EnableWDSPanels',
  EnableCSSIndicators = 'specs.membersAbout.EnableCSSIndicators',
  EnableAboutMiddleware = 'specs.membersAbout.EnableAboutMiddleware',
  EnableAccessibleRCE = 'specs.membersAbout.EnableAccessibleRCE',
  UseResponsivePostsCover = 'specs.membersAbout.UseResponsivePostsCover',
  UseNewPostsCoverDefaults = 'specs.membersAbout.UseNewPostsCoverDefaults',
}
